import classNames from 'classnames'
import { FC, useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Autoplay, Navigation, Pagination } from 'swiper/modules'
import { Swiper as SwiperType } from 'swiper'

import { ProductSelectors } from 'store/product/selectors'
import { CategoriesSelectors } from 'store/category/selectors'
import { BannerImage } from 'assets/images'
import { getBestSellers, getProducts } from 'store/product/actions'
import { filterTypes, accordionItems } from 'utils'
import { useAppDispatch, useAppSelector } from 'libraries/redux'
import { Accordion, ProductCard, ProductCardSkeleton, Tabs } from 'components'

import styles from './Home.module.scss'

const HomeContainer: FC = () => {
  const perPage = 16
  const swiperRef = useRef()
  const navigate = useNavigate()
  const dispatch = useAppDispatch()

  const { data: storeInfo } = useAppSelector(CategoriesSelectors.storeInfo)
  const { data: productList, loading } = useAppSelector(ProductSelectors.productList)


  const bannersList = storeInfo?.banners?.length ? storeInfo?.banners : storeInfo?.category?.banners
  const defaultBanners = bannersList?.length
    ? bannersList
    : !loading
    ? [
        {
          media_id: 0,
          original: BannerImage,
        },
      ]
    : []

  const updateSearchValues = (id: number) => {
    const orderBy = tabs.find(item => item.id === id)
    const isBestseller = orderBy?.order === 'bestseller'

    if (isBestseller) {
      dispatch(getBestSellers(''))
    } else {
      dispatch(
        getProducts({
          order_by: orderBy?.order,
          page: 1,
          per_page: 16,
          core_filter: '',
          filter_has_special: orderBy?.id === 3 ? true : false,
          category_filter: [Number(process.env.REACT_APP_CATEGORY_ID)],
          price_to: '',
          price_from: '',
        })
      )
    }
  }

  useEffect(() => {
    updateSearchValues(tabs[0].id)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const updateIndex = (swiperInstance: SwiperType) => {
    if (swiperInstance === null) return
  }

  const renderCardComponents = productList?.map((item: any, index:number) => (
    <ProductCard data={item} key={item.product_id || `product-${index}`} isWishlist={item?.in_wishlist} className={styles.card} />
  ))
  const productCardSkeletons = Array.from({ length: perPage }).map((_, index) => <ProductCardSkeleton key={index} />)

  const tabs = filterTypes.map((tabItem,tabIndex) => ({
    id: tabItem.id,
    text: tabItem.text,
    order: tabItem.order,
    ContentComponents: (
      <>
        {loading ? (
          <div key={tabIndex} className={styles.tabs__wrapper}>
            <div className={styles.tabs}>{productCardSkeletons}</div>
          </div>
        ) : (
          <div key={tabIndex} className={styles.tabs__wrapper}>
            <div className={styles.tabs}>{renderCardComponents}</div>
            <button onClick={() => navigate(`/products?filter=${tabItem.filter}`)} className={styles.tabs__more}>
              Перейти на каталог
            </button>
          </div>
        )}
      </>
    ),
  }))

  const renderBannerSlider = defaultBanners?.map((data: any) => (
    <SwiperSlide key={data.media_id}>
        <div className={styles.banner_container}>
          <div className={styles.banner_details} >
              <div>
              <span>{storeInfo?.category?.name}</span>
              <h1>{data?.h1}</h1>
              <p>{data?.description}</p>
                  {data.product_id?
              <a href={`/product/${data.product_id}`}>
                  Перейти к товару
              </a> : null}
              </div>

          </div>
      <img
        onClick={() => {
          if (data?.product_id) {
            navigate(`/product/${data.media_id}`)
          }
        }}
        src={data.original}
      />
        </div>
    </SwiperSlide>
  ))

  const pagination = {
    clickable: true,
    renderBullet: function (_: number, className: string) {
      return `<span class="${className}" style="{}"> </span>`
    },
  }

  return (
    <>
      <section className={classNames(styles.banner, 'bannerslider')}>
        <Swiper
          loop={renderBannerSlider?.length > 1}
          initialSlide={0}
          onBeforeInit={(swiper: any) => {
            swiperRef.current = swiper as any
          }}
          onRealIndexChange={updateIndex}
          pagination={pagination}
          modules={[Autoplay, Pagination, Navigation]}
          spaceBetween={28}
          slidesPerView={1}
          loopAdditionalSlides={renderBannerSlider?.length > 1 ? 1 : 0}
        >
          {renderBannerSlider}
        </Swiper>
      </section>

      <section>
        <div className='container'>
          <h2 className={styles.wrapper__catalog_title}>Каталог</h2>
          <div>
            <Tabs
              className={styles.wrapper__catalog}
              tabsClassName={styles.wrapper__catalog_tabs}
              tabs={tabs}
              onClick={updateSearchValues}
            />
          </div>
        </div>
      </section>

      <section>
        <div className={styles.wrapper__questions}>
          <div className={classNames('container', styles.wrapper__questions_container)}>
            <div className={styles.wrapper__questions_container_left}>
              <p className={styles.wrapper__questions_container_left_title}>Часті запитання</p>

              <span className={styles.wrapper__questions_container_left_description}>
                У вас є питання? Ми відповіли на найпоширеніші з них, щоб зробити вашу покупку ще зручнішою та
                приємнішою.
              </span>
            </div>

            <div className={styles.wrapper__questions_container_right}>
              <Accordion items={accordionItems} />
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className={classNames('container', styles.wrapper_info)}>
            <div className={styles.wrapper_info_container}>
                <div className={styles.wrapper_info_container_left}>
                    <p className={styles.wrapper_info_container_left_title}>{storeInfo?.name} </p>
                </div>
                <div className={styles.wrapper_info_container_right}>

                    <div
                        className={styles.wrapper_info_right_description}
                        dangerouslySetInnerHTML={{ __html: storeInfo?.description }}
                    />

                </div>
            </div>
          {/*<div className={styles.wrapper_info_left}>*/}

          {/*</div>*/}

          {/*<div className={styles.wrapper_info_right}>*/}
          {/*  <p className={styles.wrapper_info_right_title}>{storeInfo?.name} </p>*/}
          {/*  <div*/}
          {/*    className={styles.wrapper_info_right_description}*/}
          {/*    dangerouslySetInnerHTML={{ __html: storeInfo?.description }}*/}
          {/*  />*/}
          {/*</div>*/}
        </div>
      </section>
    </>
  )
}

export default HomeContainer